
const backendUrl = process.env.REACT_APP_CLOUD_FUNCTIONS_ENDPOINT_URL;
const freudUrl = process.env.REACT_APP_FREUD_URL;

export const getUsers = (idToken: string) => async (params: { role: string, group: string, email: string }) => {
    const url = new URL(`${backendUrl}/users`)
    Object.entries(params).forEach(([key, value]: [string, string | undefined]) => value && url.searchParams.append(key, value))

    return await fetch(url.toString(), {
        method: "get",
        headers: {
            Authorization: `idToken ${idToken}`,
            "Content-Type": "application/json",
        },
    });
}

export const getSubscriptions = (idToken: string) => async (params: { tier: string }) => {
    const url = new URL(`${backendUrl}/subscriptions`)
    Object.entries(params).forEach(([key, value]: [string, string | undefined]) => value && url.searchParams.append(key, value))

    return await fetch(url.toString(), {
        method: "get",
        headers: {
            Authorization: `idToken ${idToken}`,
            "Content-Type": "application/json",
        },
    });
} 

export const getUsage = (idToken: string) => async (params: { userId: string, fromTimestamp: number; toTimestamp: number; }) => {
    const url = new URL(`${freudUrl}/api/v1/session-metrics/session-hours`)
    Object.entries(params).forEach(([key, value]: [string, string | number | undefined]) => value && url.searchParams.append(key, String(value)))

    return await fetch(url.toString(), {
        method: "get",
        headers: {
            Authorization: `idToken ${idToken}`,
            "Content-Type": "application/json",
        },
    });
} 